/**
 * Discriminant for case-file OCR text fetch state (useCaseFileOcrText / OcrTextBody).
 */
export const OCR_STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCESS: "success",
  NOT_FOUND: "not_found",
  ERROR: "error",
} as const;

export type CaseFileOcrStatus =
  | { kind: typeof OCR_STATUS.IDLE }
  | { kind: typeof OCR_STATUS.LOADING }
  | { kind: typeof OCR_STATUS.SUCCESS; text: string }
  | { kind: typeof OCR_STATUS.NOT_FOUND }
  | { kind: typeof OCR_STATUS.ERROR; message: string };
